/* eslint-disable prefer-const */
import Offer from "types/Offer";
import { Status } from "types/Offer";
import { offersMultiPlanListType } from "types/OffersSlice";

const prepareMultiPlanList = (offersList: Offer[]): offersMultiPlanListType => {
  const multiplanOffers = offersList.filter((offer: Offer) => offer.multiPlanOffer);

  // Sort based on status
  const statusOrder: Partial<Record<Status, number>> = {
    cancelled: 1,
    active: 2,
    pendingActivation: 3,
    provisioning: 4,
    purchasable: 5,
    purchasableExternally: 6,
    cardExpired: 7,
    cardPending: 8,
    notPurchasable: 9,
    maintenance: 10,
    frozen: 11,
    optInRequested: 12,
  };

  multiplanOffers.sort((a, b) => {
    const statusComparison =
      (statusOrder[a.marketplaceInfo.status] ?? Number.MAX_SAFE_INTEGER) -
      (statusOrder[b.marketplaceInfo.status] ?? Number.MAX_SAFE_INTEGER);

    if (statusComparison !== 0) {
      return statusComparison;
    }

    return parseFloat(a.marketplaceInfo.price) - parseFloat(b.marketplaceInfo.price);
  });

  let offersMultiPlanList: offersMultiPlanListType = {};

  for (let index = 0; index < multiplanOffers.length; index++) {
    const offer: Offer = multiplanOffers[index];
    if (offersMultiPlanList[offer.partner]) {
      offersMultiPlanList[offer.partner].extraPlanOffers.push(offer);
    } else {
      offersMultiPlanList[offer.partner] = {
        mainOffer: offer,
        extraPlanOffers: [],
      };
    }
  }

  return offersMultiPlanList;
};

export default prepareMultiPlanList;
